import { ErrorHandler, Injectable, Injector } from "@angular/core";
import { IonicHelper } from "../helpers/ionic.helper";

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  
  constructor(
    private injector: Injector,
  ) {}
  
  
  
  
  handleError(error: any): void {
    // do something with the error
    // console.error(err);
    // console.dir(err);
    // console.log(err.rejection);
    const ionic = this.injector.get(IonicHelper);
    
    if(error.hasOwnProperty('rejection')) {
      console.error(error);
      if(error.rejection === 'invalid views to insert') {
       ionic.uncoverableErrorAlert('PAGE_NOT_FOUND');
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/app.error-handler.ts